import { IDataModel, Model } from 'libs/core/application';

export interface ScormData extends IDataModel {
    id?: number;
    title?: string;
    uuid?: string;
    origin_file?: string;
    entry_url?: string;
    resource_id?: string;
}
export class Scorm extends Model<ScormData> {
    id: number;
    title: string;
    uuid: string;
    origin_file: string;
    entry_url: string;
    resource_id: string;
}
